import { render, staticRenderFns } from "./salesPreferential.vue?vue&type=template&id=fdcae9b8&scoped=true&"
import script from "./salesPreferential.vue?vue&type=script&lang=js&"
export * from "./salesPreferential.vue?vue&type=script&lang=js&"
import style0 from "./salesPreferential.vue?vue&type=style&index=0&id=fdcae9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcae9b8",
  null
  
)

export default component.exports